import React from "react";
import Layout from "../../../components/shared-components-wrapper/LayoutWrapper";
import { SEO } from "../../../components";
import SalaryCalculator from "../../../components/salary-calculator/SalaryCalculator";

const displayPrimaryCTA = "/demo/?utm_source=salary_calculator";

const SalaryCalculatorPage = () => (
  <Layout
    showAnnouncementBanner={false}
    region="IN"
    displayPrimaryCTA={displayPrimaryCTA}
  >
    <SalaryCalculator />
  </Layout>
);

export default SalaryCalculatorPage;

export const Head = ({ location: { pathname } }) => (
  <>
    <SEO
      title="Salary Calculator – Calculate In-Hand & Take-Home Salary"
      desc="Use our salary calculator to calculate your in-hand and take-home salary. Estimate deductions, income tax and net salary based on your earnings."
      pathname={pathname}
    />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link
      rel="preconnect"
      href="https://fonts.gstatic.com"
      crossOrigin="anonymous"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&display=swap"
      rel="stylesheet"
    />
  </>
);
